
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[topCategoryName]",
      function () {
        return require("private-next-pages/help/[topCategoryName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[topCategoryName]"])
      });
    }
  